import React from "react";
import "../Styling/Navi1DashBoard.css";
import Navi1StaCard from "../Components/Navi1StaCard";


const Navi1Dashboard = () => {
  return (
    <div className="Navi1Dashboard-container">
      <div className="main-content">
        <div className="card-wrapper">
          <Navi1StaCard

            title="Total Employee"
            value="240"
            color="#DE09CB"
          />

          <Navi1StaCard

            title="New Hire"
            value="45"
            color="#26A69D"
          />

          <Navi1StaCard

            title="Leads"
            value="35"
            color="#FFA00F"
          />

          <Navi1StaCard

            title="Expiring Docs"
            value="4"
            color="#1CC642"
            alert
          />
        </div>
      </div>
    </div>
  );
}

export default Navi1Dashboard;